import clsx from "clsx";
import type { HistoryModeSelectedEvent } from "@/features/history/historyEvents";
import type { HistoryMode } from "@/features/history/historyMode";

export interface HistoryModeToggleViewProps {
  mode: HistoryMode;
  onEvent: (event: HistoryModeSelectedEvent) => void;
  className?: string;
}

type HistoryModeToggleProps =
  | HistoryModeToggleViewProps
  | (Omit<HistoryModeToggleViewProps, "onEvent"> & {
      onChange: (mode: HistoryMode) => void;
    });

export function HistoryModeToggleView({
  mode,
  onEvent,
  className,
}: HistoryModeToggleViewProps): React.ReactElement {
  return (
    <fieldset className={clsx("history-mode-toggle", className)}>
      <legend className="sr-only">表示する履歴</legend>
      <button
        type="button"
        aria-pressed={mode === "viewed"}
        onClick={(): void =>
          onEvent({ type: "history/mode-selected", mode: "viewed" })
        }
      >
        閲覧履歴
      </button>
      <button
        type="button"
        aria-pressed={mode === "posted"}
        onClick={(): void =>
          onEvent({ type: "history/mode-selected", mode: "posted" })
        }
      >
        書込履歴
      </button>
    </fieldset>
  );
}

/** 閲覧履歴と書込履歴を同じ表示領域へ接続するPassive View。 */
export function HistoryModeToggle(
  props: HistoryModeToggleProps,
): React.ReactElement {
  const onEvent =
    "onEvent" in props
      ? props.onEvent
      : (event: HistoryModeSelectedEvent): void => props.onChange(event.mode);
  return <HistoryModeToggleView {...props} onEvent={onEvent} />;
}
